module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC43NSAxOC43NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlNWU2ZTc7fS5jbHMtMntmaWxsOiNjZTFmMmU7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI5LjM4IiBjeT0iOS4zOCIgcj0iOS4zOCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEwLjcxLDEyLjcxLDkuMTksMTAuNTIsNy43LDEyLjcxSDZsMi4zMy0zLjJMNi4xNCw2LjQxSDcuOGwxLjQ0LDIsMS40My0yaDEuNTdsLTIuMTksMywyLjM1LDMuMjZaIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/cross-video.svg
// module id = 922
// module chunks = 173